// extracted by mini-css-extract-plugin
module.exports = {"BackToTop":"BackToTop_BackToTop__3uBll","hide":"BackToTop_hide__1XLaD","show":"BackToTop_show__O-XpM"};